import React from 'react';
import { Helmet } from 'react-helmet-async';
import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import BlogPreviewSection from '../components/BlogPreviewSection';
import ContactSection from '../components/ContactSection';
import ExperienceTimeline from '../components/ExperienceTimeline';
import SkillsSection from '../components/SkillsSection';
import ProjectsSection from '../components/ProjectsSection';
import PortfolioSection from '../components/PortfolioSection';
import TestimonialsSection from '../components/TestimonialsSection';
import FAQSection from '../components/FAQSection';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>Manikandan Sivasankar | Strategic Project Manager & Scrum Master</title>
        <meta name="description" content="Manikandan Sivasankar is a Strategic Project Manager with 16+ years of experience in Agile, SAFe, and digital transformation across Banking, Insurance, Technology, Healthcare & Telecom. Expert in cloud modernization, AEM, and Salesforce integration." />
        <meta name="keywords" content="Manikandan Sivasankar, Project Manager, Scrum Master, Product Owner, Agile Coach, SAFe, Digital Transformation, Cloud Modernization, Azure, Salesforce, AEM, Banking, Insurance, Technology, Healthcare, Telecom" />
        <link rel="canonical" href="https://manikandansivasankar.com/" />
        <meta property="og:title" content="Manikandan Sivasankar | Strategic Project Manager & Scrum Master" />
        <meta property="og:description" content="Strategic Project Manager with 16+ years driving digital transformation across Banking, Insurance, Technology, Healthcare & Telecom. Expert in Agile, SAFe, Azure, Salesforce & AEM." />
        <meta property="og:url" content="https://manikandansivasankar.com/" />
        <meta property="og:type" content="profile" />
        <meta property="og:image" content="https://customer-assets.emergentagent.com/job_mani-showcase-4/artifacts/pslvzr0m_Mani.png" />
      </Helmet>
      <div className="min-h-screen bg-white">
        <Navigation />
        <HeroSection />
      
      {/* Spacer */}
      <div className="h-16 bg-gradient-to-b from-gray-50 to-white"></div>
      
      <AboutSection />
      
      {/* Spacer */}
      <div className="h-16 bg-gradient-to-b from-white to-gray-50"></div>
      
      <ExperienceTimeline />
      
      {/* Spacer */}
      <div className="h-16 bg-gradient-to-b from-gray-50 to-blue-50"></div>
      
      <ProjectsSection />
      
      {/* Spacer */}
      <div className="h-16 bg-gradient-to-b from-blue-50 to-gray-900"></div>
      
      <PortfolioSection />
      
      {/* Spacer */}
      <div className="h-16 bg-gradient-to-b from-gray-900 to-gray-50"></div>
      
      <SkillsSection />
      
      {/* Spacer */}
      <div className="h-16 bg-gradient-to-b from-gray-50 to-white"></div>
      
      <BlogPreviewSection />
      
      {/* Spacer */}
      <div className="h-16 bg-gradient-to-b from-gray-50 to-white"></div>
      
      <TestimonialsSection />
      
      {/* Spacer */}
      <div className="h-16 bg-gradient-to-b from-white to-gray-50"></div>
      
      <FAQSection />
      
      {/* Spacer */}
      <div className="h-16 bg-gradient-to-b from-gray-50 to-blue-600"></div>
      
      <ContactSection />
      
      <Footer />
      </div>
    </>
  );
};

export default HomePage;